<div class="!p-4 border border-palette-gray-200 shadow-sm bg-white rounded-lg !mt-2 admin-custom">
    <p class="text-palette-gray-900 text-base font-semibold !pb-1">{{ 'COMMENTS.ACTIVITY' | translate }}</p>
    <div class="tab-view-custom">
        <tab-view>
            <tab-panel title="{{ 'COMMENTS.NOTES' | translate }}">
                <app-comments [id]="id"></app-comments>
            </tab-panel>

            <tab-panel title="{{ 'COMMENTS.HISTORY' | translate }}">
                <app-history [id]="id"></app-history>
            </tab-panel>
        </tab-view>
    </div>
</div>